import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * SWOOP-271 — the public customer page behind a magic link: `/r/<token>`.
 *
 * Deliberately a TOP-LEVEL route, in neither layout group:
 * - not under `_authenticated`, because the recipient has no account (that is the whole feature); and
 * - not under `_public` either, even though it is public — that group redirects any AUTHENTICATED
 *   visitor away to the dashboard, which would break the tenant admin opening the link from the
 *   Document test screen to see what the customer sees.
 *
 * `/activate` is the same shape and the precedent for it.
 *
 * The token is a path param rather than a search param, matching the emailed URL. It is not validated
 * here: the server is the only thing that can say whether a token is real, and a malformed one must
 * land on the page's own "this link is not valid" state rather than a router error.
 *
 * The token IS in this URL and cannot not be — but the page sets `referrer: no-referrer` (see the
 * component), so the browser does not attach this URL to the API calls the page then makes, keeping
 * a live bearer credential out of the API tier's access logs.
 */
export const Route = createFileRoute('/r/$token')({
  component: lazyRouteComponent(() => import('&/features/magic-link/pages/magic-link-page')),
  staticData: { titleKey: 'magicLink' },
});
